import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { authenticate } from '../../store/actions/login';
import './index.scss';

const UserAvatar = ({ primeiroNome, codigo, bgClass }) => (
  <div className={`UserAvatar ${bgClass}`}>
    <i class="medium material-icons">account_circle</i>
    <div className="user-info">
      <div className="user-name">{`${primeiroNome}`}</div>
      <span className="user-cro">{`Cod. do prestador: ${codigo}`}</span>
    </div>
  </div>
);

UserAvatar.defaultProps = {
  bgClass: null,
  primeiroNome: null,
  ultimoNome: null,
  codigo: null
};

UserAvatar.propTypes = {
  primeiroNome: PropTypes.string,
  ultimoNome: PropTypes.string,
  codigo: PropTypes.number,
  bgClass: PropTypes.string
};

function splitFirstAndLastName(name = '') {
  const splitedName = name.split(' ');
  const first = splitedName[0] || '';
  const last = splitedName[splitedName.length - 1] || '';

  return [first, last];
}

function capitalize(value = '') {
  const firstLetter = value
    .toLowerCase()
    .charAt(0)
    .toUpperCase();

  const remainingLetters = value.substring(1, value.length).toLowerCase();

  return `${firstLetter}${remainingLetters}`;
}

const mapStateToProps = ({ login }) => {
  const [primeiroNome, ultimoNome] = splitFirstAndLastName(login.user.nomeUsuario);

  return {
    login,
    primeiroNome: capitalize(primeiroNome),
    ultimoNome: capitalize(ultimoNome),
    codigo: login.user.codigo
  };
};

export default connect(
  mapStateToProps,
  { authenticate }
)(UserAvatar);
